const contacts = {
  gustavo: 'gustavosohne38@gmail.com',
  marta: 'martabrietzke@gmail.com',
  rodrigo: 'ramprofissional@gmail.com',
}

export default contacts
